import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Box from './Box';
import styles from './PickUpPointTag.module.css';

import type { FC, HTMLAttributes } from 'react';

interface PickUpPointTagProps extends HTMLAttributes<HTMLDivElement> {
  size?: 's' | 'm';
  color?: 'light' | 'dark';
}

const PickUpPointTag: FC<PickUpPointTagProps> = (props) => {
  const { className, size = 's', color = 'light', ...restProps } = props;
  const { t } = useTranslation();
  const text = t('ui.pick-up-point.tag');

  return (
    <div
      {...restProps}
      className={cn(styles.tag, className, {
        [styles.small]: size === 's',
        [styles.middle]: size === 'm',
        [styles.light]: color === 'light',
        [styles.dark]: color === 'dark',
      })}
    >
      <Box className={styles.box} />
      {text}
    </div>
  );
};

export default PickUpPointTag;
